import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/Form';
import { IconButton } from '../components/UI';
import Button from '../components/Button';
import Icon from '../components/Icon';
import { useTheme } from '../context/ThemeContext';
import { resetTutorial } from '../tutorial/TutorialProvider';

type Section = { title: string; steps: string[] };

export default function Help() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const sections = t('help.sections', { returnObjects: true }) as Section[];
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const replay = () => {
    resetTutorial();
    navigate('/home');
  };

  return (
    <main className="sls-page">
      <PageHeader title={t('help.title')} right={<IconButton icon="arrow-left" accessibilityLabel={t('help.back')} onPress={() => navigate(-1)} />} />
      <div className="sls-page-content">
        <p style={{ margin: '0 0 18px', fontSize: 16, color: colors.textSub, lineHeight: 1.55 }}>{t('help.intro')}</p>
        {sections.map((section, index) => {
          const isOpen = openIndex === index;
          return (
            <section key={section.title} style={{ borderBottom: `1px solid ${colors.line}` }}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} style={{ width: '100%', minHeight: 64, display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', border: 0, background: 'transparent', color: colors.text, textAlign: 'left', fontSize: 17, fontWeight: 700 }}>
                <span style={{ flex: 1 }}>{section.title}</span>
                <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} size={14} color={colors.textMuted} />
              </button>
              {isOpen ? <ol style={{ margin: '0 0 18px', paddingLeft: 22, color: colors.textSub, fontSize: 15, lineHeight: 1.6 }}>{section.steps.map(step => <li key={step} style={{ marginBottom: 7 }}>{step}</li>)}</ol> : null}
            </section>
          );
        })}
        <Button label={t('help.replay')} variant="secondary" onClick={replay} style={{ marginTop: 24 }} />
        <Button label={t('help.contact')} onClick={() => { window.location.href = `mailto:${t('auth.login.supportEmail')}`; }} style={{ marginTop: 10 }} />
      </div>
    </main>
  );
}
